// Centralized Demo Presets & Data for SeryiFlow / Keyla CRM

export const DEMO_BARBERIA_SERVICES = [
  { id: 'srv-barb-1', nombre: 'Corte Fade / Degradado', precio: 35000, duracion_minutos: 45, categoria: 'Cortes', stock: 25, stock_minimo: 5, control_stock: true, descripcion: 'Corte moderno con degradado a navaja y peinado profesional.' },
  { id: 'srv-barb-2', nombre: 'Barba & Perfilado (Toalla Caliente)', precio: 25000, duracion_minutos: 30, categoria: 'Barba', stock: 20, stock_minimo: 5, control_stock: true, descripcion: 'Perfilado de barba con vapor ozono, toalla caliente y aceites hidratantes.' },
  { id: 'srv-barb-3', nombre: 'Combo VIP: Corte + Barba + Mascarilla', precio: 55000, duracion_minutos: 75, categoria: 'Combos', stock: 15, stock_minimo: 5, control_stock: true, descripcion: 'Servicio integral con mascarilla de carbón activado exfoliante.' },
  { id: 'srv-barb-4', nombre: 'Pomada Modeladora Efecto Mate 100g', precio: 38000, duracion_minutos: 0, categoria: 'Productos', stock: 6, stock_minimo: 10, control_stock: true, descripcion: 'Fijación fuerte sin brillo para peinados estructurados.' },
  { id: 'srv-barb-5', nombre: 'Tónico Estimulante para Barba 60ml', precio: 45000, duracion_minutos: 0, categoria: 'Productos', stock: 3, stock_minimo: 8, control_stock: true, descripcion: 'Fórmula con minoxidil vegetal y vitamina E.' }
];

export const DEMO_RESTAURANTE_SERVICES = [
  { id: 'srv-rest-1', nombre: 'Pizza Suprema Artesanal Familiar', precio: 48000, duracion_minutos: 30, categoria: 'Pizzas', stock: 35, stock_minimo: 10, control_stock: true, descripcion: 'Masa madre 48h, mozzarella de búfala, pepperoni y albahaca fresca.' },
  { id: 'srv-rest-2', nombre: 'Hamburguesa Angus Doble + Papas Rústicas', precio: 36000, duracion_minutos: 25, categoria: 'Hamburguesas', stock: 28, stock_minimo: 12, control_stock: true, descripcion: '300g carne Angus, queso cheddar fundido, tocineta caramelizada.' },
  { id: 'srv-rest-3', nombre: 'Costillas BBQ Ahumadas (500g)', precio: 54000, duracion_minutos: 35, categoria: 'Platos Fuertes', stock: 4, stock_minimo: 8, control_stock: true, descripcion: 'Cocción lenta 12 horas en madera de roble con salsa BBQ casera.' },
  { id: 'srv-rest-4', nombre: 'Cerveza Artesanal IPA 330ml', precio: 14000, duracion_minutos: 0, categoria: 'Bebidas', stock: 48, stock_minimo: 15, control_stock: true, descripcion: 'Cerveza rubia con notas cítricas y amargor balanceado.' },
  { id: 'srv-rest-5', nombre: 'Volcán de Chocolate Belga', precio: 18000, duracion_minutos: 15, categoria: 'Postres', stock: 5, stock_minimo: 10, control_stock: true, descripcion: 'Bizcocho fluido con helado artesanal de vainilla.' }
];

export const DEMO_INMOBILIARIA_SERVICES = [
  { id: 'srv-inmob-1', nombre: 'Asesoría de Inversión y Portafolio', precio: 150000, duracion_minutos: 60, categoria: 'Asesorías', stock: 20, stock_minimo: 5, control_stock: true, descripcion: 'Análisis financiero de rentabilidad y plusvalía inmobiliaria.' },
  { id: 'srv-inmob-2', nombre: 'Estudio de Títulos & Avalúo Comercial', precio: 350000, duracion_minutos: 120, categoria: 'Legal', stock: 12, stock_minimo: 3, control_stock: true, descripcion: 'Revisión jurídica completa de tradición y libertad.' },
  { id: 'srv-inmob-3', nombre: 'Paquete Destacado + Tour Virtual 360°', precio: 490000, duracion_minutos: 180, categoria: 'Marketing Inmobiliario', stock: 3, stock_minimo: 6, control_stock: true, descripcion: 'Producción fotográfica HDR y tour interactivo Matterport.' },
  { id: 'srv-inmob-4', nombre: 'Recorrido Presencial Guiado', precio: 0, duracion_minutos: 45, categoria: 'Visitas', stock: 50, stock_minimo: 10, control_stock: true, descripcion: 'Visita guiada con un broker especializado al inmueble.' }
];

export const getDemoServicesForBusiness = (businessId) => {
  const idStr = String(businessId);
  if (idStr === '9002') return DEMO_RESTAURANTE_SERVICES;
  if (idStr === '9003') return DEMO_INMOBILIARIA_SERVICES;
  return DEMO_BARBERIA_SERVICES;
};

export const DEMO_MESSAGE_TEMPLATES = [
  {
    id: 'tpl-bienvenida',
    nombre: 'Mensaje de Bienvenida Automático',
    trigger: 'Primer contacto por WhatsApp',
    categoria: 'Atención al Cliente',
    activo: true,
    contenido: '¡Hola {{nombre}}! 👋 Bienvenido a *{{negocio}}*. Soy tu asistente virtual 24/7. ¿En qué te puedo ayudar hoy? Puedes consultar nuestro menú/servicios o agendar directamente.',
    variables: ['{{nombre}}', '{{negocio}}']
  },
  {
    id: 'tpl-recordatorio',
    nombre: 'Recordatorio Anti-Inasistencia (2 horas antes)',
    trigger: '2 horas antes de la cita',
    categoria: 'Agenda',
    activo: true,
    contenido: 'Hola {{nombre}} ⏰ Te recordamos tu cita para *{{servicio}}* hoy a las *{{hora}}* en *{{negocio}}*. ¿Nos confirmas tu asistencia respondiendo *SI*?',
    variables: ['{{nombre}}', '{{servicio}}', '{{hora}}', '{{negocio}}']
  },
  {
    id: 'tpl-confirmacion',
    nombre: 'Confirmación de Reserva / Pedido',
    trigger: 'Al agendar cita o registrar pedido',
    categoria: 'Transaccional',
    activo: true,
    contenido: '✅ ¡Listo {{nombre}}! Tu reserva para *{{servicio}}* ha sido confirmada para el día *{{fecha}}* a las *{{hora}}*. ¡Te esperamos!',
    variables: ['{{nombre}}', '{{servicio}}', '{{fecha}}', '{{hora}}']
  },
  {
    id: 'tpl-recuperacion',
    nombre: 'Recuperación de Cliente Inactivo (20 días)',
    trigger: '20 días sin interacción',
    categoria: 'Fidelización',
    activo: true,
    contenido: '¡Hola {{nombre}}! ✨ Hace tiempo no te vemos en *{{negocio}}*. Tenemos un regalo especial de bienvenida para tu próximo servicio: 15% OFF con el código *VUELVEPRONTO*. ¿Te gustaría agendar esta semana?',
    variables: ['{{nombre}}', '{{negocio}}']
  }
];
